import { createFileRoute } from '@tanstack/react-router';
import { GlobalConfigPage } from '@/domains/platform';

// Ruta estática: gana sobre la dinámica hermana `$section` (que sigue cubriendo el resto).
export const Route = createFileRoute('/_backoffice/superadmin/global-config')({
    component: GlobalConfigPage,
});
